import { render, staticRenderFns } from "./CancerInsurance.vue?vue&type=template&id=0affc569&"
import script from "./CancerInsurance.vue?vue&type=script&lang=js&"
export * from "./CancerInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports